import { render } from "./HowItWorksVideo.vue?vue&type=template&id=df037076"
import script from "./HowItWorksVideo.vue?vue&type=script&lang=js"
export * from "./HowItWorksVideo.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__